import { ReactNode } from "react";
import { Primitive } from "@elastic/eui/src/services/sort/comparators";
import { Moment } from "moment-timezone";

export type Nullable<T> = T | null;

//TODO: consider work with the real column interface of Elastic ui- EuiBasicTableColumn

export interface FDTableColumn {
  //
  align?: "center" | "right" | "left";
  // if use the render method during export
  className?: string;
  copy?: number;
  dataType?:
    | "number"
    | "roundNumber"
    | "abbreviateNumber"
    | "percents"
    | "mb"
    | "gb"
    | "bytes"
    | "positiveNumber"
    | "date"
    | "string"
    | "boolean"
    | "boolean_health"
    | "availability";
  //todo: for elastic Query index,. separated for sqlstatement_fetch_button usage
  datatype?: string;
  exportField?: string;
  //
  field: string;
  //todo: separated for sqlstatement_fetch_button usage
  filterField?: string;
  filterbutton?: number;
  // in case a flyout opened such as sqlstatement_fetch_button:1
  flyoutContent?: number;
  //1 or 0
  flyoutTitle?: string;
  format?: "unix" | "unix_minutes" | "original_tz" | "time_span";
  groupByDimension?: boolean;

  // groupByField?: string; // default is "name" or we can use groupByField
  groupByReducer?: "Avg" | "Count" | "Sum" | "Max" | "Min" | "Distinct Count";
  // when server side sorting in use - send to server different name than the field name
  icon?: React.SVGProps<SVGSVGElement> | string | undefined;
  /** deprecated use field not id*/
  id?: string;
  //1 or 0
  indexType?: string;
  /**
   * @deprecated defaultvisible is not in use anywhere. It was in the past when we had a column picker
   */
  // defaultvisible?: 0 | 1;
  name: string;
  //render?: (colValue: string | number | boolean, row?: any) => JSX.Element | null;
  render?: (colValue: any, row?: any) => ReactNode;

  //excel field
  renderExcel?: (colValue: any, row?: any) => ReactNode;

  serverSortFieldName?: string;
  // so the global object of [filterField] will be updated instead of [field]
  sortField?: string;

  sortable?: boolean | ((item: any) => Primitive);
  //1 or 0
  sqlstatement_button?: number;
  //1 or 0
  sqlstatement_fetch_button?: number;
  //1 or 0
  tooltip?: number;
  // todo: boolean
  truncateText?: boolean;
  useRenderForExcel?: boolean;
  width?: string | number; // when server side sorting in use - send to server different name than the field name
  color?: string;
  skipOnGroupBy?: boolean;
  fullWidth?: boolean;
}

type TableHeaderGroupByAggregationFunctions =
  | "Avg"
  | "Count"
  | "Sum"
  | "Max"
  | "Min"
  | "Distinct Count";
export type TableHeaderGroupByAggregation = {
  field: string;
  groupByReducer?: TableHeaderGroupByAggregationFunctions;
};

export type Column = FDTableColumn; //patch for refactoring bug

type ControlType =
  | "text"
  | "textarea"
  | "select"
  | "combobox"
  | "checkbox"
  | "phone"
  | "linephone"
  | "file"
  | "radio"
  | "radiogroup"
  | "password"
  | "number"
  | "switch"
  | "mask"
  | "linephone"
  | "percentage"
  | "date_picker"
  | "time_picker"
  | "duration"
  | "searchable";

// OBSOLETE= use ControlType type ^^ instead of this enum
export enum InputType {
  CheckBox = "checkbox",
  ComboBox = "combobox",
  File = "file",
  LinePhone = "linephone",
  Password = "password",
  Phone = "phone",
  Radio = "radio",
  RadioGroup = "radiogroup",
  Select = "select",
  Text = "text",
  TextArea = "textarea",
  DatePicker = "textarea",
}

type Validations =
  | "firstName"
  | "lastName"
  | "preferredName"
  | "userTitle"
  | "city"
  | "email"
  | "alphanumericextended" //todo: replace with concrete validation for the field
  | "phone"
  | "linePhone"
  | "positiveNumber"
  | "zip"
  | "numeric"
  | "password"
  | "time"
  | "collector"
  | "serversList"
  | "accountDisplayName"
  | "accountName";

//OBSOLETE -use Validations type ^^ instead of this enum
export enum ValidationTypes {
  Alphanumericextended = "alphanumericextended",
  City = "city",
  Email = "email",
  FirstName = "firstName",
  LastName = "lastName",
  LinePhone = "linePhone",
  Numeric = "numeric",
  Password = "password",
  Phone = "phone",
  PositiveNumber = "positiveNumber",
  PreferredName = "preferredName",
  Time = "time",
  UserTitle = "userTitle",
  Zip = "zip",
}

export enum ClientManagementType {
  Inactive = 0,
  ActiveNoCollection = 1,
  ManagedCollection = 2,
  Monitoring = 3, // OR Alerting
}
//todo: split by control type and inherit?
export interface IControl {
  //for mask
  controlProps: any;
  // additional to other props
  copy?: boolean;
  // copy icon
  defaultToSingleOption?: boolean;
  //select
  disableCreation?: boolean;
  //combobox
  disabled?: (sourceObject: any) => boolean;
  fdType?: string;
  //select
  field: string;
  fileTypes?: any[];
  // for file uploader {name:string,type:string}
  filterFunc?: (option: any, index: number, SourceObject: any) => any;
  firstOption?: string;
  //Select by default
  grow?: boolean;
  helpText?: ReactNode | ReactNode[];
  // form row
  hideRequiredSymbol: boolean;
  hideSelectOption?: boolean;
  //select
  horizontal?: boolean;
  //radiogroup
  initialPromptText?: string;
  //file
  inputType?: ControlType | InputType;
  //required. InputType is obsolete
  isVisible?: (sourceObject: any) => void;
  label: string | JSX.Element;
  //for mask?
  mask: string | undefined;
  mustMatchExactField?: string;
  noSuggestions?: boolean;
  onChange?: (controlObj: any, newVal: any, errMessage: string, newText: any) => any; //combobox
  options?: any[]; //select
  permissionGroup?: any;
  readonly?: boolean;
  render?: (value: any) => any;
  required?: boolean; // form row
  selectedIndex?: number;
  selectedName?: string;
  selectedValue?: string;
  showCheckboxRowLabel?: boolean; //checkbox
  showLabel?: boolean;
  size: number;
  getValue?: (value: any) => any;
  validation?: Validations | ValidationTypes;
  visibleIf?: (source: any) => boolean;
  placeholder?: string;
  style?: any;
  selectCustomAll?: boolean;
  singleSelection?: boolean;
}

export interface ClientInfo {
  address: string;
  address2: string;
  addressTypeID: Nullable<number>;
  alertsFromEmailAddress: string;
  alertsToEmailAddress: string;
  billingEmailAddress: string;
  city: string;
  clientID: Nullable<number>;
  clientManagementType: string;
  clientManagementTypeID: number;
  clientStatusID: Nullable<number>;
  conferencePhoneNumber: string;
  conferencePinCode: string;
  description: string;
  displayName: string;
  dropBoxFolderName: string;
  harvestClientID: Nullable<number>;
  harvestClientName: string;
  helpContactEmailAddress: string;
  helpDeskPhoneNumber: string;
  insertDate: string;
  instanceCount: number;
  isOnboardingComplete: boolean;
  licensedCount: Nullable<number>;
  logo: string;
  mFAType: string;
  mainPhoneNumber: string;
  msP_ID: number | null;
  msP_Name: string;
  name: string;
  notes: string;
  planType: Nullable<string>;
  primaryContactID: Nullable<number>;
  primaryContactName: string;
  secondaryAccountManagerUserID: Nullable<number>;
  secondaryAccountManagerUserName: string;
  serviceEndDate: Nullable<string>;
  serviceStartDate: Nullable<string>;
  shortName: string;
  slackChannel: string;
  state: string;
  tamEmailAddress: string;
  teamID: Nullable<number>;
  technicalAccountManagerUserID: Nullable<number>;
  technicalAccountManagerUserName: string;
  topFindingsServer: string;
  updateDate: Nullable<string>;
  zendeskOrganizationID: Nullable<number>;
  zendeskOrganizationName: string;
  zip: string;
}

interface ReduxClientState {
  GlobalTopFilterObject: any;
  clientId: Nullable<number>;
  clientInfo: ClientInfo;
  AssessmentTopFilterObject: any;
}

export interface ReduxState {
  auth: ReduxAuthState;
  globalFilter: ReduxClientState;
}

export interface ReduxAuthState {
  allowedClients: Array<FdClient>;
  currentUser: Nullable<FdUser>;
  isLoggedIn: boolean;
  permissions: any;
}

interface FdUser {
  userID: number;
}

interface FdClient {
  clientID: number;
  displayName: string;
  name: string;
}

export interface ApiResponse<TResult> {
  data?: TResult;
  errors?: Array<{ message: string; title: string }>;
}

export interface LookupResponse {
  id: number;
  name: string;
}

type SortOrder = "ASC" | "DESC" | "asc" | "desc";

type ElasticAggregationName =
  | "SUM"
  | "MAX"
  | "MIN"
  | "CARDINALITY"
  | "AVG"
  | "PERCENTILES"
  | "VALUE_COUNT"
  | "TOP_1_HIT"
  | "TOP_1_HIT_SUBSTR"
  | "MOVING_AVG"
  | "TOP_METRICS"
  | "FILTERS";

export interface ElasticAggregation {
  // changes field name in server response
  IsFieldScripted?: boolean;
  aggFunction?: ElasticAggregationName;
  displayAggFunction?: string;
  field?: string;
  // used for top metrics aggregation
  fieldAlias?: string;
  fields?: string[];
  filters?: Record<string, Record<string, string[]>>; // for filters aggregation
  order?: string;
  orderDirection?: SortOrder;
  percents?: any;
  titleAlias?: string;
  // turns aggFunction_field into alias on client side
  value?: number;
}

export interface ExcelExportTableOptions {
  columns: Array<FDTableColumn>;
  data: Array<any>;
  sheetName?: string;
}

export enum EChartSeriesAggregation {
  None,
  Sum,
  AVG,
  Max,
}

export interface FilterField {
  field: string; // from global filter object for example
  sendToServerName?: string; //dont send the field but this name
}

export interface IDateRange {
  end: string | Moment;
  start: string | Moment;
}

export interface PerfmonChartSyncEventPayload {
  dateRange: IDateRange;
  // isAutoRefresh: boolean;
  selectedInterval: string;
  // refreshInterval: number;
  // servername: string;
}

export type MetricDirection = "up" | "down" | "no change";

export interface ValidationState {
  errors: { [key: string]: React.ReactNode[] };
  isValid: boolean;
}

export interface ClientInfoSaveParams {
  alerting: boolean;
  alertsFromEmailAddress: string;
  alertsToEmailAddress: string;
  collection: boolean;
  displayName: string;
  logo: string;
  monitoringTypeID?: number;
  msP_ID: number;
  tamEmailAddress: string;
  ticketingSystemId?: string;
}

export interface NewClientSaveParams extends ClientInfoSaveParams {
  name: string;
}

enum AuditUserActions {
  Login = 1,
}
export interface AuditUserAction {
  eventTypeID: AuditUserActions;
}

export interface HostCapacityPlanningRecommendations {
  Recommendation: number;
  Resource: "Compute" | "Drive Space" | "Memory";
  ServerName: string;
}

export interface DateRangeFields {
  endDateField: string;
  startDateField: string;
}
